<template>
  <v-card>
    <v-card-title :style="style" class="px-2">
      <v-btn icon @click="$emit('closeScheduledItemsDialog')">
        <v-icon color="white">mdi-keyboard-backspace</v-icon>
      </v-btn>
      Scheduled Personal Property
    </v-card-title>
    <v-card-text class="pa-0">
      <SmallTableCard
        :title="totalPremiumTitle"
        :items="schedules"
        three-column
        :headers="['Limit', 'Premium']"
        :fields="[ { name: 'name', type: ''}, { name: 'limits', type: ''}, { name: 'premium', type: 'currency'} ]" />
    </v-card-text>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading Scheduled Property...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style>
</style>

<script>
import SmallTableCard from '@/components/Shared/SmallTableCard.vue';
import apiService from '@/services/shared/agentPortalApiService.js';
import coverageTranslator from '@/services/clientViewer/coverageTranslator.js';
import displayFormatterService from '@/services/shared/displayFormatterService.js';

export default {
  name: 'HomeScheduledProperty',
  components: { SmallTableCard },
  props: {
    clientId: {
      type: String,
      required: true
    },
    policyOrderNumber: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      scheduledPropInfo: null,
      loading: true,
      style: {
        'background-color': this.$vuetify.theme.themes.light.integrity,
        color: 'white'
      }
    };
  },
  computed: {
    formattedTotalPremium: function () {
      if ((this.scheduledPropInfo || null) === null) {
        return 0;
      }
      return displayFormatterService.formatCurrency(this.scheduledPropInfo.totalPremium);
    },
    totalPremiumTitle: function () {
      return 'Total Premium ' + this.formattedTotalPremium;
    },
    schedules: function () {
      if ((this.scheduledPropInfo || null) === null) {
        return [];
      }
      return this.scheduledPropInfo.schedules;
    }
  },
  created: async function () {
    this.loading = true;

    var rs = await apiService.getHomeScheduledProperty(this.clientId, this.policyOrderNumber);
    if (rs.code === 0) {
      if (rs.data.length === 0) this.scheduledPropInfo = {};

      this.scheduledPropInfo = coverageTranslator.translateHomeScheduledProperty(rs.data);
    } else {
      this.error = true;
      this.setError(rs.message);
    }

    this.loading = false;
  }
};
</script>
